import { FetchError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { SPACES_API_PATH } from '../../common/constants';

const getDeleteSpacePath = (spaceId: string) => `${SPACES_API_PATH}/${spaceId}`;

export type DeleteSpaceFetchParams = {
	spaceId: string;
	cloudId: string;
	product: string;
	experienceId: string;
};

export const deleteSpaceFetchAction = async ({
	spaceId,
	cloudId,
	product,
	experienceId,
}: DeleteSpaceFetchParams): Promise<void> => {
	const path = getDeleteSpacePath(spaceId);
	let response: Response;
	try {
		response = await fetch(path, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product,
				'x-experience-id': experienceId,
			},
			credentials: 'include',
		});
	} catch (err) {
		const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
		throw new FetchError(
			`deleteSpaceFetch error while fetching ${path}. Original error: ${originalErrorMessage}`,
			{ errorCode: 'deleteSpaceFetchError' },
		);
	}
	if (!response.ok || response.status >= 400) {
		const body = await response.text().catch(() => '');
		throw new FetchError(
			`deleteSpaceFetch error while fetching ${path}. Original error: [Code ${response.status}] ${body}`,
			{ errorCode: 'deleteSpaceFetchError', statusCode: response.status },
		);
	}
};
